<template>
  <div class="login-page" :style="backgroundStyle">
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div
      id="content"
      class="login h-100"
      style="
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 100vh;
      "
    >
      <!-- <br> -->
      <div class="card card-style" style="width: 100%">
        <div class="content">
          <div style="text-align: center !important">
            <img
              src="../assets/images/it4d-e-samu.png"
              alt="logo"
              height="65"
              style="
                margin-top: 0.5rem !important;
                margin-bottom: 30px !important;
              "
            />
          </div>

          <!-- <h1 class="text-center font-800 font-30 mb-2">Sign In</h1> -->
          <p class="text-left font-22 mt-n2 mb-3 centered bold">
            Samu 192 Digital
          </p>
          <p class="text-left font-13 mt-n2 mb-3 centered">
            Informe seu CPF e sua senha para acessar o sistema.
          </p>
          <div class="form-custom form-label form-icon mb-3">
            <i class="bi bi-person-circle font-14"></i>
            <input
              type="cpf"
              class="form-control rounded-xs"
              id="c1"
              placeholder="CPF"
              v-model="cpf"
              v-mask="'999.999.999-99'"
              autocomplete="new-password"
            />
            <label for="c1" class="color-theme">CPF</label>
            <span>(obrigatório)</span>
          </div>
          <div class="form-custom form-label form-icon mb-3">
            <i class="bi bi-asterisk font-12"></i>
            <input
              type="password"
              class="form-control rounded-xs"
              id="c2"
              placeholder="Senha"
              v-model="password"
              autocomplete="new-password"
            />
            <label for="c2" class="color-theme">Senha</label>
            <span>(obrigatório)</span>
          </div>
          <a
            href="#"
            style="background-color: #15488a !important"
            class="btn rounded-sm btn-m text-uppercase font-700 mt-4 mb-3 btn-full shadow-bg shadow-bg-s"
            @click="login"
            >ENTRAR</a
          >
          <router-link
            to="/criar-conta"
            class="d-flex"
            style="justify-content: center"
          >
            <!-- <div>
              <a
                href="page-forgot-1.html"
                class="color-theme opacity-30 font-12"
                >Recover Account</a
              >
            </div> -->
            <router-link to="/criar-conta">
              <router-link
                to="/criar-conta"
                class="color-theme opacity-70 font-16"
                >Criar minha conta</router-link
              >
            </router-link>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      backgroundImages: [
        "login-samu-01.png",
        "login-samu-02.png",
        "login-samu-03.png",
        "login-samu-04.png",
        "login-samu-05.png",
      ],
      currentBackgroundIndex: 0,
      new_path: "/dashboard",
      email: "",
      password: "",
      forgot: {
        email: "",
      },
      isLoading: false,
      loadingColor: "#5D9CEC",
    };
  },
  computed: {
    backgroundStyle() {
      const imagePath = require(`@/assets/images/${
        this.backgroundImages[this.currentBackgroundIndex]
      }`);
      return {
        backgroundImage: `url(${imagePath})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      };
    },
  },
  created() {
    this.currentBackgroundIndex = Math.floor(
      Math.random() * this.backgroundImages.length
    );
  },
  methods: {
    changeBackgroundImage() {
      setInterval(() => {
        this.currentBackgroundIndex =
          (this.currentBackgroundIndex + 1) % this.backgroundImages.length;
      }, 5000);
    },
    reveal() {
      var x = document.getElementById("password");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    login() {
      let self = this;
      self.isLoading = true;
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          cpf: this.cpf,
          senha: this.password,
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          self.$store.commit("usuario_id", response.data.usuario_id);
          self.$store.commit("usuario_nome", response.data.usuario_nome);
          self.isLoading = false;
          self.$router.push({ path: this.new_path });
        })
        .catch((error) => {
          self.isLoading = false;
          self.$message("Erro", "Credenciais incorretas", "error");
        });
    },

    forgotPassword() {
      const self = this;
      const api = this.$store.state.api + "user/recovery";

      axios
        .post(api, {
          email: self.forgot.email,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Solicitação realizada com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  components: { Loading },
  props: {},
  mounted: function () {
    const self = this;

    var url = self.$route.fullPath.split("?url=%2F");
    if (url[1]) {
      self.new_path = url[1];
    }
  },
};
</script>
<style scoped>
.login-page {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

input {
  color: black;
}

label {
  margin-bottom: -3px;
  margin-top: 3px;
}

.login a {
  color: #ffffff;
}

/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue